import { Component, OnInit, Injector, Input, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { filter } from 'lodash';
@Component({
	selector: 'info-we-found',
	template: `
		<div tabindex="0" *ngIf="control.controls && control.controls.length > 0" class="extended-info-we-found-container">
			<div class="container-header">
				<div class="help-box-container" *ngIf="control.tooltip">
					<tooltip [tooltip]="control.tooltip"></tooltip>
				</div>

				<div class="header-title">{{ control.attributes.title }}</div>
			</div>

			<control *ngFor="let control of control.controls" [control]="control" context="page"></control>

			<div class="close-button-container">
				<div
					tabindex="0"
					(keyup)="closeInfoWeFound($event)"
					class="save-close"
					(click)="saveForm()"
					gtm-handler
					events="click"
					handlerType="dataValue"
					label="Info_We_Found_Save_And_Close"
					[value]="getStageName()"
					action="ButtonClick"
				>
					Save & Close
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./extended-info-we-found.component.scss'],
})
export class ExtendedInfoWeFoundComponent extends BaseComponent implements OnInit {
	@Output() close: EventEmitter<any> = new EventEmitter();
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		(<any>this.control).controls = filter(this.control.controls, (c) => c.visible);
		this.splunkAnalyticsService.publish('Display', 'InfoWeFound_Edit_Popup');
	}

	saveForm() {
		this.setAnswer(this.control.attributes.value);
		this.ajaxAction();
		this.splunkAnalyticsService.publish('ButtonClick', 'InfoWeFound_Edit_Popup_SaveUpdates');
	}
	getStageName() {
		return this.storeService.getState().data.ui.page.title;
	}

	closeInfoWeFound(event) {
		//close 'info-we-found' window on 'Enter' or 'Space' key
		if (event.keyCode === 13 || event.keyCode === 32) {
			this.saveForm();
		}
	}
}
